import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gyan-manthan',
  templateUrl: './gyan-manthan.component.html',
  styleUrls: ['./gyan-manthan.component.scss']
})
export class GyanManthanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
